// ** Reactstrap
import { Button, Spinner } from "reactstrap";

import ActionWrapper from "../action-wrapper";
import CustomTooltip from "@components/ui-components/tooltip";
// ** Third Party
import classNames from "classnames";
import { generateRandomString } from "@src/utility/helpers/utils";
import size from "lodash/size";
import { useTranslation } from "react-i18next";

const LoadingButton = (props) => {

    const {
        loading = false,
        onClick = () => console.log("Button clicked"),
        color = "primary",
        text = "",
        className = "",
        disabled = false,
        testId = "",
        icon = "",
        subject = "",
        action = "",
        outline = false,
        id = "",
        tooltip = ""
    } = props;
    const { t } = useTranslation();
    const tempId = String(generateRandomString(4) + id).replace(/ /g, "_").replace(
        /([!"#$%&'()*+-_,./:;<=>?@[\\\]^`{|}~])/g,
        ""
    );
    return (
        <ActionWrapper
            subject={subject}
            action={action}
            child={
                <>
                    {size(tooltip) ? <CustomTooltip
                        target={`Id-${tempId}`}
                        content={tooltip}/> : null}
                    <Button
                        id={`Id-${tempId}`}
                        data-cy={testId}
                        color={color}
                        outline={outline}
                        onClick={onClick}
                        // size="sm"
                        className={classNames("d-flex justify-content-center px-1", { [className]: className })}
                        disabled={disabled || loading}>
                        {loading ? (
                            <> <Spinner color="light" size="sm" type="grow" /> {t("Loading...")}</>
                        ) : <>
                            {icon ?  <i className={`mdi mdi-${icon} ${!tooltip && text ? "me-lg-50" : ""} font-medium-2`} /> : null}
                            <span>
                                {t(text)}
                            </span>
                        </>
                        }
                    </Button>
                </>
            }/>
    );
};

export default LoadingButton;